import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { apiCallBegan } from "../actions/middlwares/api";
import { ucEndpoints } from "../config/config";
import { AppDispatch } from "../reducers";
import { Basemap } from "../types/basemaps";

export type BasemapSlice = {
  loading: boolean;
  basemaps: Basemap[];
};

const initialState: BasemapSlice = {
  loading: false,
  basemaps: []
};

const basemapsSlice = createSlice({
  name: "basemaps",
  initialState,
  reducers: {
    startGetBasemaps(state) {
      state.loading = true;
    },
    getBasemapsSuccess(state, action: PayloadAction<Basemap[]>) {
      state.basemaps = action.payload;
      state.loading = false;
    },
    getBasemapsFailure(state) {
      state.loading = false;
    }
  }
});

export const getBasemaps = () => (dispatch: AppDispatch) => {
  dispatch(
    apiCallBegan({
      url: `${ucEndpoints.basemaps}`,
      method: "get",
      onStart: startGetBasemaps,
      onSuccess: getBasemapsSuccess,
      onFailure: getBasemapsFailure
    })
  );
};
export const { startGetBasemaps, getBasemapsSuccess, getBasemapsFailure } = basemapsSlice.actions;

export default basemapsSlice.reducer;
